<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h3 class="card-title">Remover Dashboard</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p class="mb-3">
                                    Tem certeza que deseja remover o dashboard
                                    <strong>{{ dashboard.name }}</strong
                                    >? <br />
                                    <span
                                        >Esta ação não poderá ser
                                        desfeita.</span
                                    >
                                </p>
                                <div class="form-group">
                                    <label class="form-label"
                                        >Para confirmar a remoção, digite abaixo
                                        o texto
                                        <span class="bg-red-lt px-1">{{
                                            dashboard.name
                                        }}</span
                                        >:</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="dashboardNameConfirmation"
                                        id="confirmationButton"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col">
                                <a
                                    href="/dashboards/"
                                    class="btn btn"
                                    id="cancelAndBackButton"
                                >
                                    <i class="ti ti-arrow-left"></i>
                                    Cancelar e voltar
                                </a>
                            </div>
                            <div class="col-auto">
                                <a
                                    v-on:click="removeDashboard"
                                    class="btn btn-danger"
                                    id="removeDashboardButton"
                                >
                                    <i class="ti ti-trash"></i>
                                    Remover o dashboard
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "../services/api"
import EventBus from "../services/event-bus"

export default {
    name: "DashboardDeletePage",
    data() {
        return {
            dashboardNameConfirmation: "",
            dashboard: {}
        }
    },
    async mounted() {
        var id = this.$route.params.id
        var response = await Api.dashboards.get(id)
        this.dashboard = response.data
    },
    methods: {
        async removeDashboard() {
            var id = this.$route.params.id
            try {
                if (this.validate()) {
                    await Api.dashboards.delete(id)

                    this.$router.push("/dashboards")

                    EventBus.emit("message", {
                        type: "success",
                        message: "Dashboard removido com sucesso!"
                    })
                }
            } catch (error) {
                EventBus.emit("message", {
                    type: "error",
                    message: "Erro ao remover Dashboard:" + error
                })
            }
        },
        validate() {
            if (this.dashboard.name !== this.dashboardNameConfirmation) {
                EventBus.emit("message", {
                    type: "warning",
                    message:
                        "O nome do dashboard não confere com o nome digitado!"
                })

                return false
            }
            return true
        }
    }
}
</script>
